/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MainSettings {
  RegisterFishSmsText = 2,
  OnlinePaymentSmsText = 7,
  SendSmsAlertMessage = 8,
  ExtraReceiversForOrganizationSms = 9,
  DefaultNumber = 10,
  AuthenticatedMobileSmsText = 11,
  LowestCreditOfUser = 12,
  ExtraNotificationTakerUsers = 13,
  ResetPasswordSmsText = 14
}
